// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"voting-buttons_buttonGroup___vijv"};